import React from 'react';
import {Outlet} from 'react-router-dom'

import Container from "@mui/material/Container";
import Box from "@mui/material/Box";


const Authentication = () => {
    return (
        <React.Fragment>
            <Box sx={{
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left:0,
                zIndex: -2,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundImage: "url(/img/login-background.jpg)"
            }}/>
            <Box sx={{
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left:0,
                zIndex: -1,
                backgroundColor: "rgba(0,0,0,0.15)"
            }}/>
            <Container component="main" maxWidth="xs">
                <Box sx={{
                    my: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: 5,
                    backgroundColor: "rgba(255,255,255,0.85)"
                }}>
                    <Box component="img" alt="LivignoItaly logo" src="/img/logo_b1_300.png" sx={{width: "100%", px: 3, pt: 1, pb: 4}}/>
                    <Outlet/>
                </Box>
            </Container>
        </React.Fragment>
    )
};

export default Authentication;